"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.V1QuantumGraph = exports.NodeWrapper = void 0;
const error_1 = require("../error");
const graph_1 = require("../graph");
class NodeWrapper {
}
exports.NodeWrapper = NodeWrapper;
class QuantumNode {
    constructor(name) {
        this.id = 'node-' + Math.random().toString(16).substr(2);
        this.incoming = [];
        this.name = name;
    }
    getIncoming(port) {
        return this.incoming[port];
    }
    lookupColumn(columnName, datasetRepo) {
        columnName = columnName.toLowerCase();
        return this.getSignature(datasetRepo).columns.find(col => col.name === columnName);
    }
    connect(downstream, portNumber = 0) {
        if (downstream.checkPort(portNumber))
            downstream.incoming[portNumber] = this;
        else
            throw new error_1.default('Cannot connect nodes');
        return this;
    }
    toGraph() {
        if (this instanceof V1QuantumGraph)
            return this;
        let graph = new V1QuantumGraph();
        this.connect(graph);
        return graph;
    }
    // Serialization
    serialize(attributes = {}) {
        return {
            id: this.id,
            ...attributes,
            incoming: this.incoming.map(node => node.serialize()),
        };
    }
    // --- General graph operations below
    // Depth-first search
    /* eslint-disable no-unused-vars */
    dfs(predicate) {
        for (let node of this.incoming)
            node.dfs(predicate);
        predicate(this);
    }
    /* eslint-enable no-unused-vars */
    /* eslint-disable no-unused-vars */
    map(predicate) {
        let nodeMap = {};
        this.dfs((node) => {
            let value = predicate(node);
            nodeMap[node.id] = value;
            node.incoming.forEach((pNode, i) => {
                value.setIncoming(i, nodeMap[pNode.id]);
            });
        });
        return nodeMap[this.id];
    }
}
exports.default = QuantumNode;
class V1QuantumGraph extends QuantumNode {
    static from(obj) {
        // if (obj['type'] === 'root' && obj['version'] === GraphVersions.V1)
        if (obj['type'] === 'root')
            return new V1QuantumGraph(obj['signature']);
        return null;
    }
    constructor(signature = null) {
        super('Graph Root');
        this.signature = signature;
    }
    getVersion() {
        return graph_1.GraphVersions.V1;
    }
    getSignature(datasetRepo) {
        if (this.incoming[0])
            return this.incoming[0].getSignature(datasetRepo);
        return null;
    }
    checkPort(portNumber) {
        return portNumber === 0;
    }
    validate(datasetRepo) {
        return !!this.incoming[0] && this.incoming[0].validate(datasetRepo);
    }
    serialize() {
        return super.serialize({
            type: 'root',
            version: graph_1.GraphVersions.V1,
        });
    }
}
exports.V1QuantumGraph = V1QuantumGraph;
